<style lang="scss" scoped>
  #billing-show {
    .plan-select {
      display: inline-flex;
      width: auto;

      select {
        margin-left:13px;
        margin-right:13px;
      }
    }

    .header-text {
      b {
        font-weight: 700;
      }
    }

    .change-plan-link {
      margin-left: 10px;
      color: #857a98;
      font-size: 10px;
      letter-spacing: -0.15px;
      line-height: 20px;
    }

    .fit-left {
      max-width: 11%;
      flex: 0 0 11%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .fit-right {
      max-width: 89%;
      flex: 0 0 89%;
    }

    .fit-plan-button {
      max-width: 26%;
      flex: 0 0 26%;
    }

    .fit-plan-select {
      max-width: 74%;
      flex: 0 0 74%;

      select {
        max-width: 400px;
      }
    }
  }

  @media (max-width: 1500px) {
    .btn {
      font-size: 11px;
    }
  }
</style>
<template>
  <div class="row header-text mb-5px">
    <div class="px-0">
      <span>
        {{ __('Plano') }}:<b v-if="! changingPlan"> {{ currentPlan.name }}</b>
      </span>
    </div>
    <div>
      <div
        class="row"
        v-if="changingPlan"
      >
        <div class="col-8 fit-plan-select">
          <select
            class="form-control form-select"
            v-model="newPlan"
          >
            <option>{{ __('Selecione um plano') }}</option>
            <option
              v-for="plan in plans"
              :value="plan"
            >
              {{ plan.name }}
            </option>
          </select>
        </div>
        <div class="col-4 fit-plan-button px-0">
          <button
            class="btn btn-primary"
            @click.prevent="confirmPlanChange"
            :disabled="! newPlan"
          >
            {{ __('Trocar Plano') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  props: {
    currentPlan: {
      type: Object,
      required: false,
    },
  },

  data () {
    return {
      plans: [],
      newPlan: null,
      changingPlan: false,
    };
  },

  created () {
    this.$http.get('/billing/plans')
      .then(({ data }) => {
        this.plans = data;
      });
  },

  methods: {
    confirmPlanChange () {
      if (! this.newPlan) {
        return;
      }

      Swal.fire({
        icon: 'question',
        title: this.__('Você tem certeza que quer alterar seu plano?'),
        html: `<p>${this.__('Atual')}: ${this.currentPlan.name}<br>Novo: ${this.newPlan.name}</p>`,
        width: 350,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: this.__('Trocar Plano'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Cancelar'),
        showCancelButton: true,
        customClass: {
          container: 'container-swal2',
          confirmButton: 'btn btn-primary ',
          cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
        },
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          this.updatePlan();
        }
      });
    },

    updatePlan () {
      this.$http.put('billing/plan', { plan: this.newPlan.provider_id })
        .then(() => {
          this.changingPlan = false;
          this.currentPlan = this.newPlan;
          Alert.success(this.__('Plano alterado com sucesso!'));
        }).catch(() => {
          Alert.error(this.__('Erro ao salvar novo plano'));
        });
    },
  },
};
</script>
